module.exports = __webpack_public_path__ + "static/media/internship2.21a0cecc.png";